import 'Styles/usericon.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import { resetOverlay, showUserModal } from 'Actions/UiActions';
import { trackGAEvent } from 'Actions/adsActions';

import SvgIcon from 'Components/svg/SvgIcon';

import { parsePath, pathToUserProfile } from 'Utils/nav/NavHelpers';

export class UserIconComponent extends React.Component {

	shouldComponentUpdate( nextProps ) {
		// very rarely we'll update it
		return (
			!isEqual( nextProps.user, this.props.user ) ||
			!isEqual( nextProps.layout, this.props.layout ) ||
			nextProps.noAction !== this.props.noAction ||
			nextProps.className !== this.props.className
		);
	}

	_showUserModal = ( e, path, user ) => {
		e.stopPropagation();

		this.props.dispatch( resetOverlay() );
		this.props.dispatch( showUserModal( path, user ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, `userModal_${ path[1] }`, 'uiAction', 'tap' ) );
	};

	showUserProfile( e, user ) {
		e.stopPropagation();

		this.props.dispatch( resetOverlay() );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'userProfileByIcon', 'uiAction', 'tap' ) );
		this.props.dispatch( push( pathToUserProfile( user.id ) ) );
	}

	render() {
		const {user, defaultUrl, layout, noAction, className} = this.props;

		let styles = {
				backgroundImage: `url(${ user.avatar || defaultUrl })`
			},
			onlineStatus = user.online === true ? <div className="status online">online</div> : null,
			onClick = () => {},
			userLocation = user.location ? <div className="userLocation">{ user.location }</div> : null;

		if( !noAction ) {
			let path = parsePath( this.props.routing.locationBeforeTransitions.pathname );
			onClick = (e)=> { this._showUserModal( e, path, user ) };
		}

		if( this.props.onClick ) {
			onClick = this.props.onClick;
		}

		switch( layout ) {
			case 'complete':
				return (
					<div className={`uiContainer no-ad ${ className ? className : '' }`} onClick={ onClick } >
						<div className="avatar" style={ styles } />
						<div className="username">{ user.userName }</div>
						{ onlineStatus }
						{ userLocation }
					</div>
				);

			case 'nolocation':
				return (
					<div className={`uiContainer no-ad ${ className ? className : '' }`} onClick={ onClick } >
						<div className="avatar" style={ styles } />
						<div className="username">{ user.userName }</div>
						{ onlineStatus }
					</div>
				);

			case 'nostatus':
				return (
					<div className={`uiContainer no-ad ${ className ? className : '' }`} onClick={ onClick } >
						<div className="avatar" style={ styles } />
						<div className="username">{ user.userName }</div>
					</div>
				);

			case 'quote':
				return (
					<div className={`uiContainer no-ad ${ className ? className : '' }`} onClick={ onClick }>
						<div className="avatar" style={ styles } />
					</div>
				);

			case 'userprofile':
				return (
					<div className={`uiContainer no-ad ${ className ? className : '' }`} onClick={ onClick }>
						<div className="avatar" style={ styles } />
						{ onlineStatus }
					</div>
				);

			case 'sidemenu':
				return (
					<li className={`current-user ${ className ? className : '' }`}  onClick={ (e) => this.showUserProfile( e, user ) }>
						<div className="avatar" style={ styles } />
						<h2 className="username" id="sideMenuUserName">{ user.userName }</h2>
					</li>
				);

			case 'editme':
				return (
					<div className={`uiContainer no-ad ${ className ? className : '' }`}>
						<div className="avatar" style={ styles } />
						<div className="update-me" onClick={ onClick }><SvgIcon icon="photo_camera" size={ this.props.size }/></div>
					</div>
				);


			default:
				throw 'Valid layout required for UserIconComponent';
		}
	}
}

UserIconComponent.defaultProps = {
	defaultUrl: ( 'https:' === document.location.protocol ? 'https://' : 'http://' ) + 'staticimages.topify.com/default_avatar.png',
	layout: 'complete',
	className: '',
	user: {
		avatar: '',
		userName: 'Guest'
	}
};

UserIconComponent.propTypes = {
	user: PropTypes.object.isRequired,
	layout: PropTypes.string,
	dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
	return {
		routing: state.routing
	}
};

export default connect(mapStateToProps)( UserIconComponent );



// WEBPACK FOOTER //
// ./src/components/common/UserIconComponent.js